import { redirect } from 'react-router-dom'
import { jwtDecode } from 'jwt-decode'
import { getStoredUser, getToken } from 'shared/util/storage'

export const authLoader = async () => {
  const token = getToken()
  if (!token) {
    throw redirect('/login')
  }

  try {
    const decode = jwtDecode(token)
    return { ...getStoredUser(), ...decode }
  } catch (error) {
    throw redirect('/login')
  }
}
